import React from 'react';
import Seperator from '../../../seperator';
import PropTypes from 'prop-types';

function CardBottomLowestOwner({
  cardOwner
}) {
  let _cardOwner;

  if (cardOwner.length > 63) _cardOwner = `${cardOwner.slice(0, 63)}..`;
  return /*#__PURE__*/React.createElement("div", {
    className: "owner"
  }, /*#__PURE__*/React.createElement(Seperator, null, _cardOwner || cardOwner || 'CARD HOLDER'));
}

CardBottomLowestOwner.defaultProps = {
  cardOwner: ''
};
CardBottomLowestOwner.propTypes = {
  cardOwner: PropTypes.string
};
export default CardBottomLowestOwner;